<app-wa-inbox *ngIf="waService.waConversation.length === 0">

</app-wa-inbox>

<app-wa-conversation *ngIf="waService.waConversation.length >= 1">
</app-wa-conversation>